import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import ServiceIcon from "./ServiceIcon";

const pad = (n) => String(n).padStart(2, "0");

const ServiceCard = ({ service, index, variant }) => (
  <Link
    to={`/services/${service.slug}`}
    className={`svc-card ${variant === "dark" ? "svc-card--dark" : ""}`}
  >
    <div className="num">{pad(index + 1)} / Service</div>
    <div className="icon-wrap">
      <ServiceIcon name={service.icon} />
    </div>
    <h3>{service.title}</h3>
    <p>{service.short}</p>
    <span className="arrow">
      Learn more <FiArrowUpRight />
    </span>
  </Link>
);

export default ServiceCard;
